import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom'
import '../styles/global.css'
import '../styles/explore.css'
import { config } from '../server'
import { useAuth0 } from '@auth0/auth0-react';

const address = config.url.API_URL
const Explore = () => {
    const [usernames, setUsernames] = useState([])
    const [linkTo, setLinkTo] = useState('/sign-up')
    const { user, isAuthenticated } = useAuth0();

    useEffect(() => {
        if(isAuthenticated) {
            setLinkTo('/create')
        }
        fetch(address + '/api/getSets').then(res => res.json()).then(data => {
        // console.log(data)
        const data2 = data.allDocs

        let studySetInfo = []
        for(let i = 0; i < data.allDocs.length; i++) {
            if(user === undefined) {
                studySetInfo.push({studyTitle: data2[i].studyTitle, names: data2[i].name})
            }
            else {
            if(data2[i].name !== user.nickname || data2[i].name === user.nickname){
            studySetInfo.push({studyTitle: data2[i].studyTitle, names: data2[i].name})
            }
            }
        }
        const filteredArr = studySetInfo.reduce((acc, current) => {
        const x = acc.find(item => item.studyTitle=== current.studyTitle);
        if (!x) {
            return acc.concat([current]);
        } else {
            return acc;
        }
        }, []);
        setUsernames(filteredArr.reverse())
        });
    }, [user, isAuthenticated]);

    return (
        <div>
            <div className="heroContainer">
                <h1>Explore Sets</h1>
                <p>Explore the sets created by other users.</p>
            </div>
        
            <div className="recentSetsContainer" id="explore">
                <div className="recentSetsButtonContainer">
                    <Link to={linkTo} className="tealBtn verticalCenterBtn">New Set</Link>
                </div>
                {
                    usernames.map((studyInfo, i) => (
                        <Link key={i} className="setCard" to={{pathname: `${studyInfo.studyTitle}`}}>
                            <header key={i+1}>
                                <div className="setCardTitle">
                                    {studyInfo.studyTitle}
                                </div>
                                <div key={i} className="setCardAuthor">
                                    <p key={i+2} className="">Created By {studyInfo.names}</p>
                                </div>
                            </header>
                        </Link>
                    ))
                }
            </div>

        </div>
    )
}

export default Explore;